import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UseComponent } from './use.component';

const routes: Routes = [
    {
        path: 'use',
        children: [
            { path: '', component: UseComponent }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class UseRoutingModule { }
